const DEFAULT_API_ERROR_MESSAGE = 'A platform error occurred. Please try again later.';

/** Returns the upstream `error.message` from a `callJson` Error, or the fallback. */
export function extractApiErrorMessage( err: unknown, fallback: string = DEFAULT_API_ERROR_MESSAGE ): string {
  if ( !( err instanceof Error ) ) return fallback;
  const match = err.message.match( /^Status code: \d+; (.*)$/s );
  if ( !match ) return fallback;
  try {
    const body = JSON.parse( match[1] );
    const backendMessage = body?.error?.message;
    if ( typeof backendMessage === 'string' && backendMessage.length > 0 ) {
      return backendMessage;
    }
  } catch { /* fall through to fallback */ }
  return fallback;
}
